import script from "./DashboardLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&setup=true&lang=js"

import "./DashboardLayout.vue?vue&type=style&index=0&id=4d8a4f18&lang=css"
import "./DashboardLayout.vue?vue&type=style&index=1&id=4d8a4f18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d8a4f18"]])

export default __exports__